export const ASSESSMENT = '/assessment/'
export const ASSESSMENT_BULK = `${ASSESSMENT}bulk` as const
export const ASSESSMENT_ATTEMPT = `${ASSESSMENT}attempt/` as const
export const ASSESSMENT_COPY = `${ASSESSMENT}copy/` as const
export const ASSESSMENT_SUBMIT = `${ASSESSMENT}submit` as const
export const ASSESSMENT_LOG_MODAL = `${ASSESSMENT}log-open-modal` as const
export const ASSESSMENT_STUDENT_UPLOAD = `${ASSESSMENT}homework` as const
export const ASSESSMENT_CRITERIA = `${ASSESSMENT}criteria` as const
export const ASSESSMENT_CRITERIA_TYPES = `${ASSESSMENT_CRITERIA}/types` as const
export const ASSESSMENT_CRITERIA_STATUS = `${ASSESSMENT_CRITERIA}/status` as const
export const ASSESSMENT_CRITERIA_LIST = `${ASSESSMENT_CRITERIA}/list` as const
export const ASSESSMENT_STUDENT = `${ASSESSMENT}all` as const
export const ASSESSMENT_STUDENT_UPDATED = `${ASSESSMENT_STUDENT}/updated` as const
export const ASSESSMENT_STUDENT_CRITERIA_DETAILS = `${ASSESSMENT}student/criteria-details` as const
export const ASSESSMENT_STUDENT_QR_SAVE = `${ASSESSMENT}assessment_qr_list` as const
export const ASSESSMENT_STUDENT_QR_LIST = `${ASSESSMENT}student/assessment_qr_list` as const
export const ASSESSMENT_MODERATION = `${ASSESSMENT}moderation` as const
export const ASSESSMENT_QR_UPLOAD = `${ASSESSMENT}student/assessment_qr_list/upload` as const
